<template>
  <div class="user-profile">

  <!-- {{ user.preferred_distance_units }}
  {{ unitDivisor }} -->

  <form action="" class="mt-2 mx-2">
    <!-- {{ user.last_updated_date }} -->
    <small v-if="showGeneralInfo || showContactInfo || showRunningHistory || showTrainingPlanning || showMileTrial">Last Updated: {{ lastUpdated }}</small>

    <!-- <h3 class="section-header" v-if="user.first_name || user.last_name || user.birthday || user.weight || user.height">General Information</h3> -->
    <h3 class="section-header" v-if="showGeneralInfo">General Information</h3>
    <div class="row" v-if="showGeneralInfo">
      <div class="col-lg-6 form-group">
        <!-- <div class="form-row">
          <div class="col-lg-6">
            <label v-if="user.first_name">First Name</label>
            <p class="profile-element">{{ user.first_name }}</p>
          </div>
          <div class="col-lg-6">
            <label v-if="user.last_name">Last Name</label>
            <p class="profile-element">{{ user.last_name }}</p>
          </div>
        </div> -->
        <label v-if="user.first_name || user.last_name">Name</label>
        <p class="profile-element">{{ user.first_name }} {{ user.last_name }}</p>
        <label v-if="user.birthday">Birthday</label>
        <p class="profile-element">{{ user.birthday }} <span v-if="age">({{ age }})</span></p>
        <label v-if="user.gender">Gender</label>
        <p class="profile-element">{{ user.gender }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="showGeneralInfo">Preferred Distance Units</label>
        <p v-if="showGeneralInfo" class="profile-element">{{ user.preferred_distance_units }}</p>
        <label v-if="user.weight">Weight</label>
        <p class="profile-element">{{ user.weight }} {{ user.weight_units }}</p>
        <label v-if="user.height">Height</label>
        <p v-if="user.height_units == 'imperial'" class="profile-element">{{ Math.floor(user.height / 12) }} feet {{ user.height - Math.floor(user.height / 12) * 12 }} inches</p>
        <p v-if="user.height_units == 'metric'" class="profile-element">{{ user.height }} centimeters</p>
        <p v-if="BMI" class="mt-2"><span style="">BMI:</span> {{ BMI }}</p>
      </div>
    </div>
    <hr v-if="showGeneralInfo">
    <hr v-if="showGeneralInfo">
    <h3 class="section-header" v-if="showContactInfo">Contact Information</h3>
    <div class="row" v-if="showContactInfo">
      <div class="col-lg-6 form-group">
        <!-- <label v-if="user.home_phone">Home Phone</label> -->
        <label>Home Phone</label>
        <p class="profile-element">{{ user.home_phone }}</p>
        <!-- <label v-if="user.business_phone">Business Phone</label> -->
        <label>Business Phone</label>
        <p class="profile-element">{{ user.business_phone }}</p>
        <!-- <label v-if="user.cell_phone">Cell Phone</label> -->
        <label>Cell Phone</label>
        <p class="profile-element">{{ user.cell_phone }}</p>
        <!-- <label v-if="user.email">Email</label> -->
        <label>Email</label>
        <p class="profile-element">{{ user.email }}</p>
        <!-- <label v-if="user.alternate_email">Alternate Email</label> -->
        <label>Alternate Email</label>
        <p class="profile-element">{{ user.alternate_email }}</p>
        <!-- <label v-if="user.emergency_contact_name">Emergency Contact Name</label> -->
        <label>Emergency Contact Name</label>
        <p class="profile-element">{{ user.emergency_contact_name }}</p>
        <!-- <label v-if="user.emergency_contact_relation">Emergency Contact Relation</label> -->
        <label>Emergency Contact Relation</label>
        <p class="profile-element">{{ user.emergency_contact_relation }}</p>
        <!-- <label v-if="user.emergency_contact_number">Emergency Contact Number</label> -->
        <label>Emergency Contact Number</label>
        <p class="profile-element">{{ user.emergency_contact_number }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.address1">Address</label>
        <p class="profile-element">{{ user.address1 }}</p>
        <p class="profile-element">{{ user.address2 }}</p>
        <p class="profile-element">{{ user.city }}<span v-if="user.city">, </span>{{ user.provincestate }}<span v-if="user.provincestate">, </span>{{ user.country }}</p>
        <p class="profile-element">{{ user.postal_code }}</p>
      </div>
    </div>
    <hr v-if="showContactInfo">
    <hr v-if="showContactInfo">
    <h3 class="section-header" v-if="showRunningHistory">Running History</h3>
    <div class="row" v-if="showRunningHistory">
      <div class="col-lg-6">
        <label v-if="user.furthest_event">Furthest distance run/event</label>
        <p class="profile-element">{{ user.furthest_event }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.num5k != null || user.num10k != null || user.num_halfs != null || user.num_marathons != null || user.num_ultras != null || user.num_triathalons != null">Number of races completed</label>
        <p class="profile-element" v-if="user.num5k != null">5Ks: {{ user.num5k }}</p>
        <p class="profile-element" v-if="user.num10k != null">10Ks: {{ user.num10k }}</p>
        <p class="profile-element" v-if="user.num_halfs != null">Half Marathons: {{ user.num_halfs }}</p>
        <p class="profile-element" v-if="user.num_marathons != null">Marathons: {{ user.num_marathons }}</p>
        <p class="profile-element" v-if="user.num_ultras != null">UltraMarathons: {{ user.num_ultras }}</p>
        <p class="profile-element" v-if="user.num_triathalons != null">Triathalons: {{ user.num_triathalons }}</p>
      </div>
    </div>
    <hr v-if="showRunningHistory">
    <div class="row" v-if="showRunningHistory">
      <div class="col-lg-6 form-group">
        <label v-if="user.recent_weekly_distance">In the last 4 weeks, I have been running</label>
        <p v-if="user.recent_weekly_distance" class="profile-element">{{ user.recent_weekly_distance / unitDivisor }} {{ user.preferred_distance_units }} per week</p>
        <label v-if="user.recent_weekly_days">In the last 4 weeks, I have been running</label>
        <p v-if="user.recent_weekly_days" class="profile-element">{{ user.recent_weekly_days }} days per week</p>
        <label v-if="user.recent_longest_run">In the last 4 weeks, my longest run has been</label>
        <p v-if="user.recent_longest_run" class="profile-element">{{ user.recent_longest_run / unitDivisor }} {{ user.preferred_distance_units }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.longterm_weekly_distance">Over the last 2 years, the greatest distance I ran per week</label>
        <p v-if="user.longterm_weekly_distance" class="profile-element">{{ user.longterm_weekly_distance / unitDivisor }} {{ user.preferred_distance_units }}</p>
        <label v-if="user.longterm_weekly_days">Over the last 2 years, the greatest number of days I ran per week regularly</label>
        <p v-if="user.longterm_weekly_days" class="profile-element">{{ user.longterm_weekly_days }}</p>
        <label v-if="user.longterm_longest_run">Over the last 2 years, my single longest run in training was</label>
        <p v-if="user.longterm_longest_run" class="profile-element">{{ user.longterm_longest_run / unitDivisor }} {{ user.preferred_distance_units }}</p>
      </div>
    </div>
    <hr v-if="showRunningHistory">
    <div class="row" v-if="showRunningHistory">
      <div class="col-lg-6 form-group">
        <!-- <label v-if="user.best5k || user.best5k_hours || user.best5k_minutes">Best 5k race in the past 12 months</label> -->
        <label>Best 5k race in the past 12 months</label>
        <p class="profile-element">{{ user.best5k }}<span v-if="user.best5k">: </span><span v-if="user.best5k_hours || user.best5k_minutes">{{ user.best5k_hours }}<span v-if="user.best5k_hours">:</span>{{ user.best5k_minutes | twoDigits }}:{{ user.best5k_seconds | singleDecimalSeconds }}</span> ({{ user.best5k_date }})</p>
        <!-- <label v-if="user.best10k || user.best10k_hours || user.best10k_minutes">Best 10k race in the past 12 months</label> -->
        <label>Best 10k race in the past 12 months</label>
        <p class="profile-element">{{ user.best10k }}<span v-if="user.best10k">: </span><span v-if="user.best10k_hours || user.best10k_minutes">{{ user.best10k_hours }}<span v-if="user.best10k_hours">:</span>{{ user.best10k_minutes | twoDigits }}:{{ user.best10k_seconds | singleDecimalSeconds }}</span> ({{ user.best10k_date }})</p>
        <!-- <label v-if="user.best_half || user.best_half_hours || user.best_half_minutes">Best half marathon race in the past 12 months</label> -->
        <label>Best half marathon race in the past 12 months</label>
        <p class="profile-element">{{ user.best_half }}<span v-if="user.best_half">: </span><span v-if="user.best_half_hours || user.best_half_minutes">{{ user.best_half_hours }}<span v-if="user.best_half_hours">:</span>{{ user.best_half_minutes | twoDigits }}:{{ user.best_half_seconds | singleDecimalSeconds }}</span> ({{ user.best_half_date }})</p>
        <!-- <label v-if="user.best_marathon || user.best_marathon_hours || user.best_marathon_minutes">Best marathon race in the past 12 months</label> -->
        <label>Best marathon race in the past 12 months</label>
        <p class="profile-element">{{ user.best_marathon }}<span v-if="user.best_marathon">: </span><span v-if="user.best_marathon_hours || user.best_marathon_minutes">{{ user.best_marathon_hours }}<span v-if="user.best_marathon_hours">:</span>{{ user.best_marathon_minutes | twoDigits }}:{{ user.best_marathon_seconds | singleDecimalSeconds }}</span> ({{ user.best_marathon_date }})</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.recent_races">Races in the past 4-8 weeks</label>
        <p class="profile-element">{{ user.recent_races }}</p>
        <label v-if="user.recent_race_comments">Additional info/comments on these races</label>
        <p class="profile-element">{{ user.recent_race_comments }}</p>
        <label v-if="user.recent_injuries != null">Any injuries in the last 8-12 weeks?</label>
        <p class="profile-element" v-if="user.recent_injuries">Yes</p>
        <p class="profile-element" v-if="user.recent_injuries == false">No</p>
        <!-- <label v-if="user.injury_notes">Any injuries in the last 8-12 weeks?</label> -->
        <!-- <p class="profile-element">{{ user.injuries }}</p> -->
        <p v-for="(injury, index) in user.injuries" :key="index" class="profile-element">{{ injury }}</p>
        <p class="profile-element">{{ user.other_injuries }}</p>
        <p class="profile-element">{{ user.injury_notes }}</p>
      </div>
    </div>
    <hr v-if="showRunningHistory">
    <hr v-if="showRunningHistory">
    <h3 class="section-header" v-if="showTrainingPlanning">Training Planning</h3>

    <label v-if="user.plan">Season</label>
    <p class="profile-element">{{ user.season }}</p>
    <div>
      <label v-if="user.plan">Coaching Level</label>
      <p class="profile-element">{{ user.plan }}</p>
    </div>

    <div class="row" v-if="showTrainingPlanning">
      <div class="col-lg-6 form-group">
        <label v-if="user.categories[0]">Winter/Spring Season Groups</label>
        <p v-for="(category, index) in user.categories" :key="index" class="profile-element">{{ category }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.categories2[0]">Summer/Fall Season Groups</label>
        <p v-for="(category, index) in user.categories2" :key="index" class="profile-element">{{ category }}</p>
      </div>
    </div>
    <div class="row" v-if="showTrainingPlanning">
      <div class="col-lg-6 form-group">
        <label v-if="user.winterraces[0] || user.other_winter_races">Winter (Mid Season) Races</label>
        <p v-for="(race, index) in user.winterraces" :key="index" class="profile-element">{{ race }}</p>
        <p class="profile-element">{{ user.other_winter_races }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.springraces[0] || user.other_spring_races">Spring (Target) Races</label>
        <p v-for="(race, index) in user.springraces" :key="index" class="profile-element">{{ race }}</p>
        <p class="profile-element">{{ user.other_spring_races }}</p>
      </div>
    </div>
    <div class="row" v-if="showTrainingPlanning">
      <div class="col-lg-6 form-group">
        <label v-if="user.summerraces[0] || user.other_summer_races">Summer (Mid Season) Races</label>
        <p v-for="(race, index) in user.summerraces" :key="index" class="profile-element">{{ race }}</p>
        <p class="profile-element">{{ user.other_summer_races }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.fallraces[0] || user.other_fall_races">Fall (Target) Races</label>
        <p v-for="(race, index) in user.fallraces" :key="index" class="profile-element">{{ race }}</p>
        <p class="profile-element">{{ user.other_fall_races }}</p>
      </div>
    </div>
    <div class="row" v-if="showTrainingPlanning">
      <div class="col-lg-12">
        <!-- <label v-if="user.goal_race">Objective race goals for the season</label> -->
        <label>Objective race goals for the season</label>
        <p class="profile-element">{{ user.goal_race }}</p>
        <label>Subjective race goals for the season</label>
        <p class="profile-element">{{ user.subjective_goals }}</p>
      </div>
    </div>
    <hr v-if="user.goal_race">

    <div class="row" v-if="showTrainingPlanning">
      <div class="col-lg-6 form-group">
        <label v-if="user.heartrate_monitor != null">Heart rate monitor?</label>
        <p class="profile-element" v-if="user.heartrate_monitor">Yes</p>
        <p class="profile-element" v-if="user.heartrate_monitor == false">No</p>
        <label v-if="user.long_day">Preferred day for your LONG run?</label>
        <p class="profile-element">{{ user.long_day }}</p>
        <label v-if="user.speed_day">Preferred day for your SPEED run?</label>
        <p class="profile-element">{{ user.speed_day }}</p>
        <label v-if="user.rest_day">Preferred day for your DAY OFF?</label>
        <p class="profile-element">{{ user.rest_day }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.trainingaspects[0]">3 training-related aspects would you like to track during your training schedule?</label>
        <p v-for="(training_aspect, index) in user.trainingaspects" :key="index" class="profile-element">{{ training_aspect }}</p>
        <p class="profile-element">{{ user.other_training_aspects }}</p>
      </div>
    </div>
    <hr v-if="user.xtraining_amount || user.xtraining_days[0] || user.xtraining_description">
    <div class="row" v-if="showTrainingPlanning">
      <div class="col-lg-6 form-group">
        <label v-if="user.xtraining_amount">How much aerobic cross-training (cycle, swim, etc) do you plan to do?</label>
        <p class="profile-element">{{ user.xtraining_amount }}</p>
        <label v-if="user.xtraining_days[0]">Preferred days to aerobically cross-train</label>
        <p v-for="(xtraining_day, index) in user.xtraining_days" :key="index" class="profile-element">{{ xtraining_day }}</p>
      </div>
      <div class="col-lg-6 form-group">
        <label v-if="user.xtrainingactivities[0] || user.other_xtraining_activities">Preferred aerobic x-training activites</label>
        <p v-for="(activity, index) in user.xtrainingactivities" :key="index" class="profile-element">{{ activity }}</p>
        <p class="profile-element">{{ user.other_xtraining_activities }}</p>
        <label v-if="user.xtraining_description">Other (non-aerobic) cross-training</label>
        <p class="profile-element">{{ user.xtraining_description }}</p>
      </div>
    </div>
    <hr v-if="showTrainingPlanning">
    <hr v-if="showTrainingPlanning">
    <h3 class="section-header" v-if="showMileTrial">Basic Speed Assessment - 1 Mile Trial</h3>
    <div v-if="showMileTrial"v>
      <label v-if="user.mile_method">Assessment Method</label>
      <p class="profile-element">{{ user.mile_method }} <span v-if="user.estimate_mile_race && user.mile_method == 'Use Past Race to Estimate'">({{ user.estimate_mile_race }})</span></p>
    </div>
    <div class="row" v-if="showMileTrial">
      <div class="col-lg-4">
        <!-- <label v-if="user.mile_minutes">Mile Time</label> -->
        <label>Mile Time</label>
        <p v-if="user.mile_minutes" class="profile-element">{{ user.mile_minutes }}:{{ user.mile_seconds | twoDigits }}</p>
        <!-- <label v-if="user.mile_location">Location</label> -->
        <label>Date</label>
        <p v-if="user.mile_date">{{ new Date(user.mile_date).toDateString() }}</p>
        <p v-else></p>
        <label>Location</label>
        <p class="profile-element">{{ user.mile_location }}</p>
        <!-- <label v-if="user.mile_surface">Surface</label> -->
        <label>Surface</label>
        <p class="profile-element">{{ user.mile_surface }}</p>
        <!-- <label v-if="user.mile_splits">Mile Splits</label>
        <p class="profile-element">{{ user.mile_splits }}</p> -->
        <!-- <label v-if="user.mile_weather">Weather Conditions</label> -->
        <label>Weather Conditions</label>
        <p class="profile-element">{{ user.mile_weather }}</p>
      </div>
      <div class="col-lg-4">
        <label v-if="lap1Mins || lap1Secs">Lap 1</label>
        <p v-if="lap1Mins || lap1Secs" class="profile-element"><!--<span style="font-weight: 700;">Lap 1: </span>-->{{ lap1Mins }}:{{ lap1Secs }}</p>
        <label v-if="lap2Mins || lap2Secs">Lap 2</label>
        <p v-if="lap2Mins || lap2Secs" class="profile-element">{{ lap2Mins }}:{{ lap2Secs }}</p>
        <label v-if="lap3Mins || lap3Secs">Lap 3</label>
        <p v-if="lap3Mins || lap3Secs" class="profile-element">{{ lap3Mins }}:{{ lap3Secs }}</p>
        <label v-if="lap4Mins || lap4Secs">Lap 4</label>
        <p v-if="lap4Mins || lap4Secs" class="profile-element">{{ lap4Mins }}:{{ lap4Secs }}</p>
      </div>
      <div class="col-lg-4">
        <label v-if="mins800m || secs800m">800m</label>
        <p v-if="mins800m || secs800m" class="profile-element">{{ mins800m }}:{{ secs800m }}</p>
        <label v-if="mins1k || secs1k">1k</label>
        <p v-if="mins1k || secs1k" class="profile-element">{{ mins1k }}:{{ secs1k }}</p>
        <label v-if="fastestLapMins || fastestLapSecs">Fastest Lap</label>
        <p v-if="fastestLapMins || fastestLapSecs" class="profile-element">{{ fastestLapMins }}:{{ fastestLapSecs }}</p>
        <label v-if="user.mile_max_hr">Max Heart Rate</label>
        <p class="profile-element">{{ user.mile_max_hr }}</p>
      </div>
    </div>
    <div v-if="showMileTrial">
      <label v-if="user.estimate_mile">Estimate mile speed based on:</label>
      <p class="profile-element" v-if="user.estimate_mile">{{ user.estimate_mile_race }}</p>
    </div>
    <hr v-if="showMileTrial">
    <!-- <button class="btn btn-primary mt-3" style="display: block;" @click.prevent="editing = true">Edit</button> -->

  </form>

  <!-- {{ user.goal_race }} -->
  <!-- {{ user.heartrate_monitor }} -->
  <!-- {{ user.long_day }} -->
  <!-- {{ user.speed_day }} -->
  <!-- {{ user.rest_day }} -->
  <!-- {{ user.training_aspects }} -->
  <!-- {{ user.xtraining_amount }} -->
  <!-- {{ user.xtraining_days }} -->
  <!-- {{ user.xtraining_description }} -->
  <!-- (this.user.goal_race || this.user.heartrate_monitor || this.user.long_day || this.user.speed_day || this.user.rest_day || this.user.training_aspects || this.user.xtraining_amount || this.user.xtraining_days || this.user.xtraining_description) { -->

  </div>
</template>

<script>
  export default {
    props: ['user'],
    data() {
      return {
        // unitDivisor: 1000,
        // lastUpdated: '',
        lap1Mins: null,
        lap1Secs: null,
        lap2Mins: null,
        lap2Secs: null,
        lap3Mins: null,
        lap3Secs: null,
        lap4Mins: null,
        lap4Secs: null,
        mins800m: null,
        secs800m: null,
        mins1k: null,
        secs1k: null,
        fastestLapMins: null,
        fastestLapSecs: null,

        // age: null,
      }
    },
    computed: {
      showGeneralInfo() {
        if (this.user.first_name || this.user.last_name || this.user.birthday || this.user.gender || this.user.weight || this.user.height) {
          return true
        } else {
          return false
        }
      },
      showContactInfo() {
        if (this.user.home_phone || this.user.business_phone || this.user.cell_phone || this.user.alternate_email || this.user.address1 || this.user.address2 || this.user.postal_code || this.user.city || this.user.provincestate || this.user.country ) {
          return true
        } else {
          return false
        }
      },
      showRunningHistory() {
        // if (this.furthestEvent || this.num5k || this.num10k || this.numHalfs || this.numMarathons || this.numTriathalons || this.recentWeeklyDistance || this.recentWeeklyDays || this.recentLongestRun || this.longtermWeeklyDistance || this.longtermWeeklyDays || this.longtermLongestRun || this.best5kHours || this.best5kMins || this.best5kSecs || this.best5k || this.best10kHours || this.best10kMins || this.best10kSecs || this.best10k || this.bestHalfHours || this.bestHalfMins || this.bestHalfSecs || this.bestHalf || this.bestMarathonHours || this.bestMarathonMins || this.bestMarathonSecs || this.bestMarathon || this.recentRaces || this.recentRaceComments || this.recentInjuries || this.injuryNotes) {
        if (this.user.furthest_event || this.user.num5k || this.user.num10k || this.user.num_halfs || this.user.num_marathons || this.user.num_triathalons || this.user.recent_weekly_distance || this.user.recent_weekly_days || this.user.recent_longest_run || this.user.longterm_weekly_distance || this.user.longterm_weekly_days || this.user.longterm_longest_run || this.user.best5k_hours || this.user.best5k_minutes || this.user.best5k_seconds || this.user.best5k || this.user.best10k_hours || this.user.best10k_minutes || this.user.best10k_seconds || this.user.best10k || this.user.best_half_hours || this.user.best_half_minutes || this.user.best_half_seconds || this.user.best_half || this.user.best_marathon_hours || this.user.best_marathon_minutes || this.user.best_marathon_seconds || this.user.best_marathon || this.user.recent_races || this.user.recent_race_comments || this.user.recent_injuries || this.user.injuries[0] || this.user.other_injuries || this.user.injury_notes) {
          return true
        } else {
          return false
        }
      },
      showTrainingPlanning() {
        // if (this.goalRace || this.heartrateMonitor || this.longDay || this.speedDay || this.restDay || this.trainingAspects || this.xtrainingAmount || this.xtrainingDays || this.xtrainingDescription) {
        if (this.user.plan || this.user.categories[0] || this.user.categories2[0] || this.user.winterraces[0] || this.user.other_winter_races || this.user.springraces[0] || this.user.other_spring_races || this.user.summerraces[0] || this.user.other_summer_races || this.user.fallraces[0] || this.user.other_fall_races || this.user.goal_race || this.user.heartrate_monitor || this.user.long_day || this.user.speed_day || this.user.rest_day || this.user.trainingaspects[0] || this.user.other_training_aspects || this.user.xtraining_amount || this.user.xtraining_days[0] || this.user.xtraining_description) {
          return true
        } else {
          return false
        }
      },
      showMileTrial() {
        this.lap1Secs = this.convertSecondsToTime(this.user.mile_lap1).seconds
        this.lap1Mins = this.convertSecondsToTime(this.user.mile_lap1).minutes
        this.lap2Secs = this.convertSecondsToTime(this.user.mile_lap2).seconds
        this.lap2Mins = this.convertSecondsToTime(this.user.mile_lap2).minutes
        this.lap3Secs = this.convertSecondsToTime(this.user.mile_lap3).seconds
        this.lap3Mins = this.convertSecondsToTime(this.user.mile_lap3).minutes
        this.lap4Secs = this.convertSecondsToTime(this.user.mile_lap4).seconds
        this.lap4Mins = this.convertSecondsToTime(this.user.mile_lap4).minutes
        this.mins800m = this.convertSecondsToTime(this.user.mile_800).minutes
        this.secs800m = this.convertSecondsToTime(this.user.mile_800).seconds
        this.mins1k = this.convertSecondsToTime(this.user.mile_1k).minutes
        this.secs1k = this.convertSecondsToTime(this.user.mile_1k).seconds
        this.fastestLapMins = this.convertSecondsToTime(this.user.mile_fastest_lap).minutes
        this.fastestLapSecs = this.convertSecondsToTime(this.user.mile_fastest_lap).seconds

        // if (this.mileMins || this.mileSecs || this.mileLocation || this.mileSurface || this.mileSplits) {
        if (this.user.mile_method || this.user.mile_minutes || this.user.mile_seconds || this.user.mile_location || this.user.mile_surface || this.user.mile_splits || this.user.mile_weather || this.lap1Mins || this.lap1Secs || this.lap2Mins || this.lap2Secs || this.lap3Mins || this.lap3Secs || this.lap4Mins || this.lap4Secs || this.mins800m || this.secs800m || this.mins1k || this.secs1k || this.fastestLapMins || this.fastestLapSecs || this.user.mile_max_hr || this.user.estimate_mile || this.user.estimate_mile_race) {
          return true
        } else {
          return false
        }
      },
      unitDivisor() {
        if (this.user.preferred_distance_units == 'km') {
          return 1000
        }
        if (this.user.preferred_distance_units == 'mi') {
          return 1609
        }
      },
      lastUpdated() {
        // Make the last updated date better formatted for humans
        // https://stackoverflow.com/questions/1168807/how-can-i-add-a-key-value-pair-to-a-javascript-object
        return new Date(this.user.last_updated_date).toDateString()
      },
      age() {
        if (this.user.birthday) {
          const oneYear = 24 * 60 * 60 * 1000 * 365
          return ((new Date() - new Date(this.user.birthday)) / oneYear).toFixed(1) // https://www.geeksforgeeks.org/round-off-a-number-upto-2-decimal-place-using-javascript/
        }
        else {
          return null
        }
      },
      BMI() {
        // <p v-if="user.height_units == 'imperial'" class="profile-element">{{ Math.floor(user.height / 12) }} feet {{ user.height - Math.floor(user.height / 12) * 12 }} inches</p>
        // <p v-if="user.height_units == 'metric'" class="profile-element">{{ user.height }} centimeters</p>
        if (this.user.height && this.user.weight) {
          // Convert height to meters
          let height = null
          if (this.user.height_units == 'imperial') {
            height = this.user.height * 0.0254
          }
          else if (this.user.height_units == 'metric') {
            height = this.user.height * 0.01
          }

          // Get weight in kg
          let weight = this.user.weight // If the units originally selected were kg then nothing more to do
          if (this.user.weight_units == 'lbs') {
            weight = weight / 2.205
          }

          if (height && weight) {
            // https://www.diabetes.ca/managing-my-diabetes/tools---resources/body-mass-index-(bmi)-calculator
            return (weight / (height * height)).toFixed(1) // https://www.geeksforgeeks.org/round-off-a-number-upto-2-decimal-place-using-javascript/
          } else {
            return null
          }
        } else {
          return null
        }
      }
    },
    created() {
      console.log('Created')
      // Make the last updated date better formatted for humans
      // https://stackoverflow.com/questions/1168807/how-can-i-add-a-key-value-pair-to-a-javascript-object
      // if (this.user.last_updated_date) {
      //   console.log('Last Updated Date')
      //   this.lastUpdated = new Date(this.user.last_updated_date).toDateString()
      // }
      // this.lap1Secs = this.convertSecondsToTime(this.user.mile_lap1).seconds
      // this.lap1Mins = this.convertSecondsToTime(this.user.mile_lap1).minutes
      // this.lap2Secs = this.convertSecondsToTime(this.user.mile_lap2).seconds
      // this.lap2Mins = this.convertSecondsToTime(this.user.mile_lap2).minutes
      // this.lap3Secs = this.convertSecondsToTime(this.user.mile_lap3).seconds
      // this.lap3Mins = this.convertSecondsToTime(this.user.mile_lap3).minutes
      // this.lap4Secs = this.convertSecondsToTime(this.user.mile_lap4).seconds
      // this.lap4Mins = this.convertSecondsToTime(this.user.mile_lap4).minutes
      // this.mins800m = this.convertSecondsToTime(this.user.mile_800).minutes
      // this.secs800m = this.convertSecondsToTime(this.user.mile_800).seconds
      // this.mins1k = this.convertSecondsToTime(this.user.mile_1k).minutes
      // this.secs1k = this.convertSecondsToTime(this.user.mile_1k).seconds
      // this.fastestLapMins = this.convertSecondsToTime(this.user.mile_fastest_lap).minutes
      // this.fastestLapSecs = this.convertSecondsToTime(this.user.mile_fastest_lap).seconds
    },
  }
</script>

<style>
  .user-profile p {
    margin-bottom: 0;
  }

  .section-header {
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserProfileInfo.vue